// extracted by mini-css-extract-plugin
export default {"ag-styles":"bx_g","versions":"bx_QP","newsletterSignup":"bx_QQ","announcement":"bx_QR"};